<template>
  <div id="myBaseInfo">
    <div class="baseinfo-left" @click="changeSpan($event)">
      <span class="baseinfo-span active-span" data-type="baseinfo">账号信息</span>
      <span class="baseinfo-span" v-if="!hkFlag" data-type="cancleinfo">账号注销</span>
    </div>
    <div class="baseinfo-right">
      <div class="baseinfo-box">
        <div class="photo">
          <img class="head-icon" :src="photoUrl" width="125" height="125">
          <div class="btn">
            <el-button type="info" plain v-if="!hkFlag"  @click="changeAvatarDialogVisible = true">更换头像</el-button>
          </div>
        </div>
        <div class="right-content">
          <div class="basic-info">
            <div class="basic-cont-left y-fc-999"><span class="y-t-ac">用户名称</span>
              <span  class="y-fc-333 y-t-al y-f-ell" v-if="userMess.nickName && userMess.nickName !== userMess.mobile">{{ userMess.nickName }}</span>
              <span class="y-fc-333 y-t-al y-f-ell" v-else>{{ userMess.encryptMobile || userMess.userName || userMess.mobile }}</span>
              <i class="el-icon-edit y-t-al y-c-p" @click="showUpdateNickNameDialog = true"></i>
            </div>
            <div class="basic-cont-left y-fc-999" v-if="!hkFlag"><span class="y-t-ac">账号密码</span>
              <span class="y-fc-333 y-t-al">********</span>
              <i class="el-icon-edit y-t-al y-c-p" @click="changePasswordDialogVisible = true"></i>
            </div>
            <div class="basic-cont-left y-fc-999" v-if="!hkFlag"><span class="y-t-ac">绑定手机</span>
              <span class="y-fc-333 y-t-al">{{encryptMobile}}</span>
              <span class="y-fc-4C84FF y-c-p y-t-ar" v-if="this.bindUserMobile"  @click="changeMobileDialogVisible = true">绑定</span>
              <i v-else class="el-icon-edit y-t-al y-c-p" @click="changeMobileDialogVisible = true"></i>
            </div>
            <div class="basic-cont-left y-fc-999" v-if="!hkFlag"><span class="y-t-ac">实名信息</span>
              <span class="y-fc-333 y-t-al y-fc-4C84FF y-c-p" v-if="!isRealName" @click="openAuthRealNameDialog('add')">您未实名认证，请先认证</span>
              <span class="y-fc-333 y-t-al" v-else>{{certInfo.cerName}}</span>
              <i class="el-icon-edit y-t-al y-c-p" :class="{'y-o-0':!isRealName}" @click="openAuthRealNameDialog('edit')"></i>
            </div>
            <div class="basic-cont-left y-fc-999" v-if="!hkFlag"><span class="y-t-ac">银行卡信息</span>
              <span class="y-fc-333 y-t-al y-fc-4C84FF y-c-p" @click="toBankCard">我的银行卡</span>
              <i class="el-icon-edit y-t-al y-c-p y-o-0"></i>
            </div>
          </div>
        </div>
      </div>
      <change-avatar :value="changeAvatarDialogVisible" @close="changeAvatar" @update="getSrc"></change-avatar>
      <change-mobile :value="changeMobileDialogVisible" :bindUserMobileInfo="this.bindUserMobileInfo" @close="changeMobileDialogVisible = false;"></change-mobile>
      <change-password :value="changePasswordDialogVisible" @close="changePasswordDialogVisible = false;"></change-password>
      <!-- 修改用户名称 -->
      <updateUserName :showUpdateNickNameDialog.sync="showUpdateNickNameDialog" />
      <!-- 实名认证 -->
      <AuthRealName  :showAuthRealNameDialog.sync="showAuthRealNameDialog" :showType="showType" :certInfo="certInfo"  @update="getIsRealName"/>
    </div>
  </div>
</template>

<script>
import img from '@/assets/images/u653.svg';
import { getStore, setStore } from '@/utils/localStorage';
import { getAvatarApi, isRealNameApi, getCertInfoApi } from '@/api/systemModule/accountSetting/info';
export default {
  name: 'accountInfoSetting',
  components: {
    ChangeAvatar: () => import('./components/ChangeAvatar.vue'),
    ChangeMobile: () => import('./components/ChangeMobile.vue'),
    ChangePassword: () => import('./components/ChangePassword.vue'),
    updateUserName: () => import('./components/updateUserName.vue'),
    AuthRealName: () => import('./components/authRealName.vue'),
  },
  data() {
    return {
      photoUrl: this.$store.state.user.photoUrl,
      encryptMobile: getStore('encryptMobile'),
      changeAvatarDialogVisible: false,
      changeMobileDialogVisible: false,
      changePasswordDialogVisible: false,
      bindUserMobile: false,
      bindUserMobileInfo: {
        'changeStatus': false,
        'title': '',
        'tipText': '',
        'step': 1
      },
      hkFlag:false,
      showUpdateNickNameDialog: false,
      isRealName: false,//是否已经实名认证，true是，false否
      realNameId: "",//实名认证id
      certInfo: {
        "loginId": "", 
        "cerNo": "", 
        "cerName": "", 
        "cerType": null, 
        "cerTypeName": "" 
      }, //实名认证信息
      showAuthRealNameDialog: false,//实名认证弹层
      showType: '',//实名认证状态add、edit
    };
  },
  computed: {
    userMess() {
      return this.$store.state.user;
    }
  },
  created() {
    this.getSrc();
    if(sessionStorage.getItem("hkorte")){
      // 香港账号
      this.hkFlag = true;
    }else{
      this.getIsRealName('first');
    }
  },
  mounted(){
    console.log(this.$route.query)
    // 修改密码弹窗打开
    if (this.$route.query.modifyPassword == 'Y' || this.$route.params.modifyPassword == 'Y') {
      this.$nextTick(()=>{
        this.changePasswordDialogVisible = true;
      })      
    }
  },
  methods: {
    toBankCard(){
      if(!this.isRealName){
        this.$confirm('您尚未实名认证，请先认证。需要认证后才能查看银行卡信息?', '提示', {
          confirmButtonText: '去认证',
          cancelButtonText: '关闭',
          type: 'warning'
        }).then(() => {
          // 去认证
          this.openAuthRealNameDialog('add');
        }).catch(() => {       
        });
        return
      }
      var tempwindow = window.open("_blank");
      let token = getStore('stewoard-token');
      let myBankCardUrl = '';
      const host = window.location.host;
      if (host.match(/^kh.yto.net.cn/i)) {
        // pro
        myBankCardUrl = 'https://stlaccount-front.yto56.com.cn:48888/h5-web/protocol-pay-pc/addBankCard/myBankCard';
      }else if (host.match(/^khsd.yto.net.cn/i)) {
        // pre
        myBankCardUrl = 'https://stlaccount-front.yto56.com.cn:48888/h5-web/protocol-pay-pc/addBankCard/myBankCard';
      }else{
        // uat
        myBankCardUrl = 'https://stlwebaccount.yto56test.com/h5-web/protocol-pay-pc/addBankCard/myBankCard';
      }
      let realNameId = this.realNameId;
      tempwindow.location = myBankCardUrl + '?source=KHGJ&token=' + token + '&realNameId='+ realNameId;
    },
    // 判断是否实名认证
    getIsRealName(code) {
      isRealNameApi().then(res => {
        if(res.data.status == 1 && res.data.data == true){
          this.isRealName = true;
          this.realNameId = res.data.realNameId;
          this.getCertInfo();
        }else{
          this.realNameId = '';
          this.isRealName = false;
        }
      }).catch(()=>{
        this.realNameId = '';
        this.isRealName = false;
      }).finally(()=>{
        if(code=='first' && !this.isRealName){
          // 首次进入
          if(this.$route.query && (this.$route.query.source=='khgj-materialBalance' || this.$route.query.source=='bankCard')){
            this.openAuthRealNameDialog('add');
          }
        }else if(code=='success' && this.$route.query && this.$route.query.source=='bankCard'){
          // 成功后回调
          this.$router.back(-1);//后退跳至银行卡页面；$router.back(-1)返回原页面路由参数仍存在
        }
      })
    },
    // 获取实名认证信息
    getCertInfo(){
      this.certInfo = {};
      getCertInfoApi().then(res => {
        if(res.data.status == 1){
          this.certInfo = res.data.data || {};
        }
      })
    },
    openAuthRealNameDialog(type){
      this.showAuthRealNameDialog = true;
      this.showType = type;
    },
    changeSpan(e) {
      if (e && e.target && e.target.dataset && e.target.dataset.type === 'cancleinfo') {
        this.$router.push({name: 'accountLogOff'});
      } else {
        this.$router.push({name: 'accountInfoSetting'});
      }
    },
    async getSrc() {
      let res = await getAvatarApi();
      if (res.response) {
        let parseRespone = JSON.parse(res.response)?JSON.parse(res.response):{};
        if(parseRespone.message == 'SUCCESS'){
          this.photoUrl = parseRespone.data;
          setStore('userAvatar', this.photoUrl);
          this.$store.commit('SET_PHOTOURL', this.photoUrl);
        }else{
          this.$store.commit('SET_PHOTOURL');
          this.photoUrl = img;
        }
      } else {
        this.$store.commit('SET_PHOTOURL');
        this.photoUrl = img;
      }
    },
    // 更换头像
    changeAvatar() {
      this.changeAvatarDialogVisible = false;
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../../../styles/variables";
  #myBaseInfo{
    background: #ffffff;
    height: 100%;
    .photo{
      text-align: center;
      padding-top: 90px;
      img{
        width: 85px;
        height: 85px;
      }
      .btn{
        margin-top: 30px;
        margin-bottom: 137px;
        button{
          width: 140px;
          height: 45px;
          background: $blue-style;
          color: #ffffff;
          border-radius: 5px;
        }
      }
    }
    .right-content{
      text-align: center;
      padding-bottom: 15%;
      .basic-cont-left{
        height: 50px;
        line-height: 50px;
        display: flex;
        align-items: center;
        font-size: 14px;
        font-weight: 400;
        span{
          flex: 1;
        }
        i {
          width: 20%;
        }
      }
    }
    .baseinfo-left{
      float: left;
      width: 10%;
      padding-top: 10px;
    }
    .baseinfo-right{
      width: 90%;
      margin-left: 10%;
      .baseinfo-box {
        width: 800px;
        margin: 0 auto;
      }
    }
    .baseinfo-span{
      border-left: 4px solid #FFFFFF;
      display: block;
      height: 42px;
      line-height: 42px;
      font-size: 14px;
      text-align: center;
      color: #666666;
      cursor: pointer;
    }
    .baseinfo-span:hover{
      border-left: 4px solid $blue-style;
      color: $blue-style !important;
      background-color: $sidebar-bg-style !important;
    }
    .baseinfo-span.active-span{
      border-left: 4px solid $blue-style;
      color: $blue-style !important;
      background-color: $sidebar-bg-style !important;
    }
  }
</style>
